import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import videoService, { VideoDoc } from '../services/videoService';
import VideoForm from '../components/videos/VideoForm';

const VideoUpsert: React.FC = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();

  const isEdit = Boolean(id);
  const isView = window.location.pathname.includes('/view');
  const [video, setVideo] = useState<VideoDoc | null>(null);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const load = async () => {
      if (!id) return;
      setLoading(true);
      try {
        const result = await videoService.getVideo(id);
        if (result.success) setVideo(result.data as VideoDoc);
      } catch (e) {
        toast.error('Failed to load video');
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [id]);

  const handleSubmit = async (success: boolean) => {
    setSaving(false);
    if (success) navigate('/videos');
  };

  const handleCancel = () => navigate('/videos');

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">
            {isView ? 'View Video' : isEdit ? 'Edit Video' : 'Add New Video'}
          </h1>
          <p className="text-gray-600 mt-1">
            {isView ? 'Video details' : isEdit ? 'Update the video details' : 'Create a new video entry'}
          </p>
        </div>
      </div>

      {loading ? (
        <div className="p-6">
          <p>Loading...</p>
        </div>
      ) : (
        <VideoForm
          video={video}
          onSubmit={handleSubmit}
          onCancel={handleCancel}
          loading={saving}
          readOnly={isView}
        />
      )}
    </div>
  );
};

export default VideoUpsert;

